import React from "react";
import PropTypes from "prop-types";
import TextInput from "components/v3/text-input/TextInput";
import ErrorHandler from "components/v3/error-handler/ErrorHandler";
import styles from "./styles.module.scss";

class Password extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showPassword: false
        };

        this._toggle = this._toggle.bind(this);
        this._onChange = this._onChange.bind(this);
    }

    _toggle() {
        const { showPassword } = this.state;

        this.setState({ showPassword: !showPassword });
    }

    _onChange(event) {
        event.preventDefault();

        this.props.onChange(event.target.value);
    }

    render() {
        const {
            password,
            errors = {},
            disabled,
            autoFocus = false,
            confirmation,
            placeholderText
        } = this.props;

        const { showPassword } = this.state;
        const toggleText = showPassword ? "Hide" : "Show";
        const toggleAriaLabel = showPassword ? "Hide Password" : "Show Password";
        const errorType = confirmation ? "confirmPassword" : "password";
        const inputName = confirmation ? "confirm password" : "password";
        const placeholder = placeholderText || (confirmation ? "Confirm password" : "Enter your password");

        return (
            <div className={ styles.inputAndToggle }>
                <ErrorHandler type={ errorType } errors={ errors }>
                    <TextInput
                        name={ inputName }
                        placeholder={ placeholder }
                        value={ password }
                        type={ showPassword ? "text" : "password" }
                        maxLength="254"
                        onChange={ this._onChange }
                        disabled={ disabled }
                        showErrors={ true }
                        autoFocus={ autoFocus }
                    />
                </ErrorHandler>
                <button type="button" className={ styles.toggle } onClick={ this._toggle } aria-label={ toggleAriaLabel }>
                    { toggleText }
                </button>
            </div>
        );
    }
}

Password.propTypes = {
    password: PropTypes.string,
    errors: PropTypes.object,
    disabled: PropTypes.bool,
    autoFocus: PropTypes.bool,
    confirmation: PropTypes.bool,
    placeholderText: PropTypes.string,
    onChange: PropTypes.func.isRequired
};

export default Password;
